import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "@/contexts/AuthContext";
import { Loader2, Check, AlertTriangle } from "lucide-react";

export default function MagicLogin() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [state, setState] = useState({ status: "loading", error: null });

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setState({ status: "error", error: "Missing token in URL." });
      return;
    }
    axios.post(`${API}/auth/magic-link/consume`, { token })
      .then((r) => {
        // Mirror what /login does — store the token + redirect.
        if (r.data?.access_token) {
          localStorage.setItem("access_token", r.data.access_token);
        }
        setState({ status: "ok", error: null });
        setTimeout(() => nav("/app/products", { replace: true }), 600);
      })
      .catch((e) => {
        const detail = e?.response?.data?.detail || e.message || "unknown";
        setState({ status: "error", error: String(detail) });
      });
  }, [params, nav]);

  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-100 flex items-center justify-center p-6"
         data-testid="magic-login-page">
      <div className="max-w-sm w-full ap-panel p-8 text-center">
        {state.status === "loading" && (
          <>
            <Loader2 className="h-8 w-8 animate-spin text-emerald-400 mx-auto mb-3" />
            <div className="text-sm text-zinc-300">Signing you in…</div>
          </>
        )}
        {state.status === "ok" && (
          <>
            <Check className="h-8 w-8 text-emerald-400 mx-auto mb-3" />
            <div className="text-sm text-zinc-200">You're in — redirecting…</div>
          </>
        )}
        {state.status === "error" && (
          <>
            <AlertTriangle className="h-8 w-8 text-rose-400 mx-auto mb-3" />
            <div className="text-sm text-zinc-200 font-semibold mb-1">Magic link rejected</div>
            <div className="text-xs text-rose-300 mono break-words" data-testid="magic-login-error">
              {state.error}
            </div>
            <a href="/login" className="inline-block mt-4 text-xs text-emerald-400 hover:text-emerald-300">
              Back to password login →
            </a>
          </>
        )}
      </div>
    </div>
  );
}
